import React, { useEffect, useState } from "react";
import { Button, Card, Col, Nav, ProgressBar, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../layouts/Footer";
import MyAppointmentTable from "../components/tables/MyAppointmentsTable";
import { AccordionData } from "../components/appointmentAccordion/AccordionData";
import AppointmentSidebar2 from "../components/common/Recent&Transaction";
import Header from "../layouts/Header";

export default function AdmissionHistory() {
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');

      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }
  };

  switchSkin(skin);
  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  return (
    <React.Fragment>
      <Header er onSkin={setSkin} />
      <Row>
        <Col>
        <div className="main main-app p-3 p-lg-4">
        <div className="d-md-flex align-items-center justify-content-between mb-4">
          <div>
            <h4 className="main-title mb-0"></h4>
          </div>
          <div className="d-flex gap-2 mt-3 mt-md-0">
           
            {/* <Button variant="" className="btn-white d-flex align-items-center gap-2">
              <i className="ri-printer-line fs-18 lh-1"></i>
            </Button> */}
            {/* <Button variant="primary" className="d-flex align-items-center gap-2">
              <i className="ri-bar-chart-2-line fs-18 lh-1"></i>Book Appointment<span className="d-none d-sm-inline"></span>
            </Button> */}
          </div>
        </div> 

        <Nav className="nav-line mb-4">
            <Nav.Link href="/history/antenatal" >Antenatal History</Nav.Link>
            <Nav.Link href="#">IVF History</Nav.Link>
            <Nav.Link href="" className="active" >Admission History </Nav.Link>
            {/* <Nav.Link href="/dashboard/previsit-form" >Pre-visit Form </Nav.Link> */}
        </Nav>
        <div className={" fw-medium mt-10 divider divider-start"}>
            <span>My Admission History</span>
        </div>

        <Row className="g-3">
         
          <Col xl="12">
            <Card className="card-one">
              <Card.Header>
                <Card.Title as="h6"></Card.Title>
                <Nav className="nav-icon nav-icon-sm ms-auto">
                  <Nav.Link href=""><i className="ri-refresh-line"></i></Nav.Link>
                  <Nav.Link href=""><i className="ri-more-2-fill"></i></Nav.Link>
                </Nav>
              </Card.Header> 

              <MyAppointmentTable data={AccordionData}/>  
            </Card>
          </Col>
          
     
       
    
        </Row>

        <Footer />
      </div>
      </Col>
      <AppointmentSidebar2 />
      </Row>
    </React.Fragment>
  );
}
